<template>
  <div class="login-container flex-b-r">
    <div class="login-body">
      <!-- 标题 -->
      <p class="title">侦迹云个人注册</p>
      <!-- 表单 -->
      <div class="SignBody">
        <div class="SignBody-child">
          <div class="left-TheName">
            <!-- 循环生成input框右侧的表单名 -->
            <p v-for="(item, index) in TheName" :key="index">
              <span v-if="item.required != '1'" style="color: red">*</span
              >{{ item.title }}：
            </p>
          </div>
          <div class="right-content">
            <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="100px"
              class="demo-ruleForm"
            >
              <el-form-item prop="username">
                <!-- 姓名框 -->
                <div class="input-place">
                  <el-input
                    v-model="ruleForm.username"
                    placeholder="请输入姓名"
                  ></el-input>
                </div>
              </el-form-item>
              <!-- 性别选择 -->
              <div class="input-place">
                <p
                  v-for="(item, index) in sexSelectArr"
                  :key="index"
                  :class="ruleForm.sex == item.id ? 'Select-p' : ''"
                  @click="ruleForm.sex = item.id"
                >
                  {{ item.Options }}
                </p>
              </div>

              <!-- 出生年月日 -->
              <div class="input-place">
                <el-form-item prop="birthday">
                  <el-date-picker
                    class="timeSelect"
                    :clearable="false"
                    v-model="ruleForm.birthday"
                    type="date"
                    placeholder="选择日期"
                    format="yyyy 年 MM 月 dd 日"
                    value-format="timestamp"
                    @change="handelChange(1)"
                    :picker-options="birthdayPickerOptions"
                  >
                  </el-date-picker>
                </el-form-item>
                <div class="ageEcho" v-if="years != ''">
                  {{ years }}
                </div>
              </div>

              <!-- 首次参加工作时间 -->
              <div class="input-place">
                <el-form-item prop="firstWorkTime">
                  <el-date-picker
                    class="timeSelect"
                    :clearable="false"
                    v-model="ruleForm.firstWorkTime"
                    type="date"
                    placeholder="选择日期"
                    format="yyyy 年 MM 月 dd 日"
                    value-format="timestamp"
                    @change="handelChange(2)"
                    :picker-options="firstWorkTimePickerOptions"
                  >
                  </el-date-picker>
                </el-form-item>
                <div class="ageEcho" v-if="yearsAge != ''">
                  {{ yearsAge }}
                </div>
              </div>
              <!-- 邮箱验证 -->
              <div class="input-place input-place-Code">
                <el-form-item prop="mail">
                  <el-input
                    v-model="ruleForm.mail"
                    placeholder="请输入个人邮箱"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="authCode">
                  <div class="Code">
                    <el-input
                      v-model="ruleForm.authCode"
                      placeholder="请输入邮箱验证码"
                    ></el-input>
                    <p class="firm-clickable" @click="second == 60 ? Countdown('ruleForm') : ''">
                      {{
                        second === totalSecond && sendNum == 0
                          ? "发送验证码"
                          : second === totalSecond && sendNum != 0
                          ? "再次发送验证码"
                          : second + `s`
                      }}
                    </p>
                  </div>
                </el-form-item>
              </div>
            </el-form>
          </div>
        </div>
        <div class="SignBody-child">
          <div class="left-TheName">
            <!-- 循环生成input框右侧的表单名 -->
            <p
              v-for="(item, index) in TheNameRight"
              :key="index"
              :class="item.style == '1' ? 'height-p' : ''"
            >
              <span v-if="item.required != '1'" style="color: red">*</span
              >{{ item.title }}
            </p>
          </div>
          <div class="right-content">
            <!-- 头像 -->
            <!-- <div class="avatar_box">
              <Avatar @handleAvatarTxUrl="handleAvatarTxUrl"></Avatar>
            </div> -->
            <!-- 身份选择 -->
            <div class="input-place">
              <p
                v-for="(item, index) in standingArr"
                :key="index"
                :class="ruleForm.work == item.id ? 'Select-p' : ''"
                @click="ruleForm.work = item.id"
              >
                {{ item.Options }}
              </p>
            </div>
            <!-- 求职状态 -->
            <div class="input-place">
              <p
                v-for="(item, index) in statusArr"
                :key="index"
                :class="ruleForm.jobStatus == item.id ? 'Select-p' : ''"
                @click="ruleForm.jobStatus = item.id"
              >
                {{ item.Options }}
              </p>
            </div>
            <!-- 求职类型 -->
            <div class="input-place">
              <p
                v-for="(item, index) in typeArr"
                :key="index"
                :class="ruleForm.jobType == item.id ? 'Select-p' : ''"
                @click="ruleForm.jobType = item.id"
              >
                {{ item.Options }}
              </p>
            </div>
            <!-- 学历 -->
            <div class="input-place Learn">
              <p
                v-for="(item, index) in learnArr"
                :key="index"
                :class="ruleForm.xl == item.id ? 'Select-p' : ''"
                @click="ruleForm.xl = item.id"
              >
                {{ item.Options }}
              </p>
            </div>
            <!-- 框 -->
            <!-- <div class="input-place" style="z-index: 999">
              <el-input
                v-model="ruleForm.recommendCode"
                placeholder="请输入推荐码(推荐人/企业的唯一ID)"
              ></el-input>
            </div> -->
          </div>
        </div>
      </div>
      <!-- 按钮 -->
      <div class="SignBtn">
        <div class="btn-box">
          <p class="firm-clickable" @click="$router.push('/login')">返回</p>
          <p class="firm-clickable" @click="handelSkipHomepage('ruleForm')">注册</p>
        </div>
      </div>
    </div>
    <div class="BaseMap"></div>
  </div>
</template>

<script>
// 封装的表单验证
import { vxRule } from "../../../untils/FormValidation/validate-form";
// 引入头像组件
import Avatar from "../../components/AvatarToken.vue";
import { mapActions } from "vuex";
// 引入接口
import {
  postUserRegister, //个人注册接口
  postSendAuthCode, // 发送短信，邮箱验证码
} from "../../assets/api/index";
export default {
  // 组件参数 接收来自父组件的数据
  props: {},
  // 局部注册的组件
  components: {
    // Avatar
  },
  // 组件状态值
  data() {
    return {
      ruleForm: {
        username: "", // 姓名
        sex: "0", // 选中的性别
        work: "0", // 身份选择选中
        birthday: "", // 出生年月日
        firstWorkTime: "", // 首次参加工作时间
        mail: "", // 邮箱
        authCode: "", //邮箱验证码
        jobStatus: "0", // 求职状态默认选中
        jobType: "0", // 求职类型 选中
        xl: "0", // 学历选中
        recommendCode: "", // 推荐码
        phone: "", // 手机号
        // userImg: "", //头像
      }, // v-mode
      years: "", // 年龄
      yearsAge: "", // 工作年
      TheName: [
        { title: "姓名" },
        { title: "性别" },

        { title: "出生年月日" },
        { title: "首次参加工作时间" },
        { title: "邮箱验证" },
      ], //表单名
      TheNameRight: [
        // { title: "头像：", required: "1" },
        // { title: "", required: "1" },
        { title: "身份：" },
        { title: "求职状态：" },
        { title: "求职类型：" },
        { title: "学历：", style: "1" },
        // { title: "推荐码：", required: "1" },
      ], //表单名
      sexSelectArr: [
        { Options: "女", id: "0" },
        { Options: "男", id: "1" },
      ], // 性别选择
      standingArr: [
        { Options: "职场精英", id: "0" },
        { Options: "学生", id: "1" },
      ], // 身份选择
      statusArr: [
        { Options: "离职-想找工作", id: "0" },
        { Options: "在职-想换工作", id: "1" },
        { Options: "在职-寻找机会", id: "2" },
        { Options: "在职-不考虑", id: "3" },
      ], // 求职状态选项
      typeArr: [
        { Options: "全职", id: "0" },
        { Options: "兼职", id: "1" },
      ], // 求职类型选项
      learnArr: [
        { Options: "初中及以下", id: "0" },
        { Options: "中专/中技", id: "1" },
        { Options: "高中", id: "2" },
        { Options: "大专", id: "3" },
        { Options: "本科", id: "4" },
        { Options: "硕士", id: "5" },
        { Options: "博士", id: "6" },
      ], // 学历选项

      totalSecond: 60, // 总秒数
      second: 60, // 倒计时的秒数
      timer: null, // 定时器 id
      sendNum: "0", // 发送次数首次叫获取验证码之后叫再次发送验证码

      rules: {
        // 参数3 change触发，为空时使用自定义提示语    blur
        // 参数4 自定义提示语 / 没有时用封装的
        // 参数2 封装的规则名 / 自定义规则
        // 参数1 false时不验证为空
        username: vxRule(true, "", "blur", "请输入姓名"),
        authCode: [
          {
            required: true,
            message: "请输入邮箱验证码",
            trigger: ["blur", "change"],
          },
        ],
        birthday: vxRule(true, "", "blur", "请选择出生年月日"),
        mail: vxRule(true, "Email", "change", "请输入个人邮箱"),
        firstWorkTime: vxRule(true, "", "blur", "请选择首次参加工作时间"),
      }, // 表单验证
      birthdayPickerOptions: {
        disabledDate(time) {
          const end = new Date();
          end.setHours(0, 0, 0, 0);
          return time.getTime() > end.getTime();
        },
      },
    };
  },
  computed: {
    firstWorkTimePickerOptions() {
      const birthday = this.ruleForm.birthday;
      return {
        disabledDate: (time) => {
          const end = new Date();
          end.setHours(0, 0, 0, 0);
          if (time.getTime() > end.getTime()) return true;
          if (!birthday) return false;
          const minWorkDate = new Date(birthday);
          minWorkDate.setFullYear(minWorkDate.getFullYear() + 16);
          minWorkDate.setHours(0, 0, 0, 0);
          return time.getTime() < minWorkDate.getTime();
        },
      };
    },
  },
  // 组件初始化
  created() {
    this.rules.firstWorkTime.push({
      validator: this.validateFirstWorkTime,
      trigger: ["blur", "change"],
    });
  },
  // 组件实例挂载完毕
  mounted() {
    this.ruleForm.phone = this.$route.query.type;
    console.log(this.ruleForm);
  },
  //销毁事件
  destroyed() {
    clearInterval(this.timer); //关闭定时器
    this.timer = null; // 重置定时器 id
    this.second = this.totalSecond; // 归位
  },
  // 组件方法
  methods: {
    ...mapActions(["SET_TOKEN", "SET_Interview", "SET_USERINFO"]),
    // 头像选择
    handleAvatarTxUrl(val) {
      // this.ruleForm.userImg = val;
    },

    // ----------------------------- postSendAuthCode (发送验证码接口) -----------------------------------
    async postSendAuthCode() {
      // 邮箱验证
      var data = {};
      data.data = { mail: this.ruleForm.mail, type: 1, authCodeBusiness: "1" };
      // 调接口
      const res = await postSendAuthCode(data);
      // 验证码发送成功
      if (res.code == 0) {
        // 验证码 发送成功 开启发送倒计时
        this.verify();
        this.$tool.PromptBox("success", "验证码已发送");
      } else {
        // 验证码发送失败
        // this.$tool.PromptBox("error", "验证码发送失败");
      }
    },
    // 点击 发送邮箱验证码
    Countdown(formName) {
      // 单独查看邮箱是否校验成功
      this.$refs[formName].validateField("mail", (errMsg) => {
        if (errMsg) {
          console.log("校验未通过");
          this.$tool.PromptBox("warning", "邮箱校验未通过");
        } else {
          console.log("校验通过");
          // 邮箱校验成功 点击获取验证码 才会往下进行
          // 调用 发送验证码倒计时  调用发送邮箱验证码接口
          this.postSendAuthCode();
        }
      });
    },
    // 发送验证码倒计时
    verify() {
      var that = this;
      // 点击发送验证码后延迟一秒 给that.sendNum加加 用于区分获取验证码 与 再次获取验证码
      setTimeout(function () {
        that.sendNum++;
        console.log(that.sendNum);
        // 时间间隔
      }, 1000);

      // 当前目前没有定时器开着，且 totalSecond 和 second 一致 (秒数归位) 才可以倒计时
      if (!this.timer && this.second === this.totalSecond) {
        console.log("111");
        // 开启倒计时
        this.timer = setInterval(() => {
          this.second--;
          // 60秒倒计时结束 关闭定时器
          if (this.second <= 0) {
            clearInterval(this.timer);
            this.timer = null; // 重置定时器 id
            this.second = this.totalSecond; // 归位
          }
        }, 1000);
      }
    },
    getAgeAtDate(birthday, targetDate) {
      const birth = new Date(birthday);
      const target = new Date(targetDate);
      let age = target.getFullYear() - birth.getFullYear();
      const monthDiff = target.getMonth() - birth.getMonth();
      if (
        monthDiff < 0 ||
        (monthDiff === 0 && target.getDate() < birth.getDate())
      ) {
        age--;
      }
      return age;
    },
    validateFirstWorkTime(rule, value, callback) {
      if (!value) {
        callback();
        return;
      }
      if (!this.ruleForm.birthday) {
        callback(new Error("请先选择出生年月日"));
        return;
      }
      if (this.getAgeAtDate(this.ruleForm.birthday, value) < 16) {
        callback(new Error("首次参加工作时间时年龄不能小于16岁"));
        return;
      }
      callback();
    },
    // 日期选择后触发
    handelChange(num) {
      // 1是出生年月日计算  2是工作年数计算
      if (num == 1) {
        //时间戳转年月日函数，用于传参
        console.log(this.ruleForm.birthday);
        console.log(this.$tool.turnTime(this.ruleForm.birthday));
        // 当前时间戳减去选择日期的时间戳计算后获取年龄
        this.years = this.$tool.compute(this.ruleForm.birthday) + "岁";
        if (this.ruleForm.firstWorkTime && this.$refs.ruleForm) {
          this.$refs.ruleForm.validateField("firstWorkTime");
        }
      } else {
        //时间戳转年月日函数，用于传参
        console.log(this.ruleForm.firstWorkTime);
        console.log(this.$tool.turnTime(this.ruleForm.firstWorkTime));
        if (
          this.ruleForm.birthday &&
          this.ruleForm.firstWorkTime &&
          this.getAgeAtDate(
            this.ruleForm.birthday,
            this.ruleForm.firstWorkTime
          ) < 16
        ) {
          this.ruleForm.firstWorkTime = "";
          this.yearsAge = "";
          this.$tool.PromptBox("warning", "首次参加工作时间时年龄不能小于16岁");
          return;
        }
        this.yearsAge = this.$tool.compute(this.ruleForm.firstWorkTime) + "年";
      }
    },
    // 点击注册   静态页面直接跳转首页
    handelSkipHomepage(formName) {
      console.log(this.ruleForm);
      // 表单校验
      //if (valid) 校验成功 调接口继续下一步
      //else 校验失败  return false;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.years.substring(0, 2) * 1 >= 18) {
            var data = {};
            data.data = this.ruleForm;
            console.log(data);
            postUserRegister(data).then((res) => {
              // 注册成功
              if (res.code == 0) {
                this.$tool.PromptBox("success", "注册成功");
                // 存个人数据 （暂时保留）
                localStorage.setItem("ID", res.data.userInfo.id);
                localStorage.setItem("LoginParty", "personage");
                // 将数据存入vuex
                var token = res.data.token;
                var userInfo = res.data.userInfo;
                this.$store.commit("SET_TOKEN", token);
                this.$store.commit("SET_USERINFO", userInfo);
                // 从企业端切换身份注册个人时，须切回个人身份，否则路由守卫仍会进企业首页
                this.$store.commit("SET_LOGINS", "0");
                // 登录记录
                this.$tool.checkLogin(localStorage.getItem("phoneVx"));
                // 跳转个人首页
                this.$router.push("/");
              } else {
                // 注册失败
                // this.$tool.PromptBox("error", res.msg);
              }
            });
            // 跳转首页 并在localStorage中存入id
            // this.$router.push("/");
            // localStorage.setItem("ID", true);
          } else {
            this.$tool.PromptBox("warning", "未满18周岁");
          }
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
/deep/.el-form-item {
  margin-bottom: 0px;
  height: 35px;
}
/deep/.el-date-editor {
  position: relative !important;
}
/deep/.el-form-item__content {
  margin-left: 0 !important;
}
// 修改el组件 input框
/deep/.el-input__inner {
  width: 360px;
  width: 100% !important;
  height: 35px;
  border: 1px solid #409eff ;
  border-radius: 5px;
  //   border-right: none;
}
/deep/ .el-date-editor--date {
  width: 360px !important;
}
/deep/.el-input__icon {
  font-size: 20px !important;
  margin-top: 0px;
}
// 年龄回显
.ageEcho {
  width: 90px;
  height: 34px;
  line-height: 34px;
  box-sizing: border-box;
  background: rgba(97, 144, 232, 0.27);
  border-left: 0.5px solid #409eff ;
  border-radius: 0px 5px 5px 0px;
  position: absolute;
  right: 0;
  top: 3px;
  font-size: 12px;
  color: #409eff ;
  text-align: center;
  font-weight: 400;
}
// 主体内容
.login-container {
  min-width: 1230px !important;
  height: 100%;
  min-height: 740px;
  display: flex;
  flex-direction: column;
  background: #0054cc;
  background-image: linear-gradient(
    90deg,
    rgba(97, 144, 232, 0.5) 0%,
    rgba(167, 191, 232, 0.5) 99%
  );
  //   border: 1px solid #979797;
  // 中心白色区域 大div
  .login-body {
    min-width: 1200px;
    min-height: 600px !important;
    font-size: 16px;
    margin: auto;
    background-color: #ffffff;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    // title 标题
    .title {
      width: 100%;
      height: 21px;
      margin-top: 40px;
      text-align: center;
      font-family: FZLTCHJW--GB1-0;
      font-size: 18px;
      color: #409eff ;
      font-weight: 600;
    }
    // 表单区域
    .SignBody {
      min-width: 1080px;
      min-height: 420px;
      margin: 0 auto;
      margin-top: 40px;
      display: flex;
      justify-content: space-between;
      z-index: 999;
      // 表单分为左右两部分
      .SignBody-child {
        min-width: 485px;
        display: flex;
        // 左侧表单
        .left-TheName {
          min-width: 110px;
          //   height: 100%;
          p {
            height: 35px;
            line-height: 35px;
            font-family: PingFangSC-Medium;
            font-size: 14px;
            color: #333333;
            text-align: right;
            font-weight: 400;
            margin-top: 30px;
          }
          p:nth-child(1) {
            margin-top: 0;
          }
          .height-p {
            height: 80px;
          }
        }
        // 右侧表单
        .right-content {
          flex: 1;
          height: 100%;
          .input-place-Code {
            display: flex;
            flex-direction: column;
            .Code {
              position: relative;
              z-index: 99;
              margin-top: 6px;
              p {
                position: absolute;
                top: 3px;
                right: 20px;
                border: none;
                background-color: transparent;
                z-index: 0;
                color: #409eff ;
              }
            }
          }
          .Learn {
            width: 420px !important;
            height: 80px !important;
            display: flex;
            flex-wrap: wrap;
            p:nth-child(5) {
              margin-left: 0;
              margin-top: 10px;
            }
            p:nth-child(6) {
              margin-top: 10px;
            }
            p:nth-child(7) {
              margin-top: 10px;
            }
          }
          .input-place {
            width: 100%;
            height: 35px;
            margin-top: 30px;
            display: flex;
            position: relative;

            .Select-p {
              background: rgba(97, 144, 232, 0.27);
              cursor: pointer;
            }
            p {
              margin-left: 15px;
              width: 90px;
              height: 35px;
              line-height: 35px;
              background: #ffffff;
              border: 1px solid #409eff ;
              border-radius: 5px;
              font-family: PingFangSC-Medium;
              font-size: 12px;
              color: #409eff ;
              text-align: center;
              font-weight: 400;
              cursor: pointer;
            }
            p:nth-child(1) {
              margin-left: 0;
            }
          }
          .input-place:nth-child(1) {
            margin-top: 0;
          }
          // 头像
          .avatar_box {
            width: 100%;
            height: 100px;
          }
        }
      }
    }
    // 底部按钮
    .SignBtn {
      width: 100%;
      height: 40px;
      display: flex;
      margin-top: 15px;
      z-index: 99;
      .btn-box {
        width: 300px;
        height: 40px;
        margin: auto;
        display: flex;
        p {
          width: 120px;
          height: 40px;
          text-align: center;
          line-height: 40px;
          margin: auto;
          font-family: PingFangSC-Medium;
          font-size: 16px;
          color: #333333;
          font-weight: 400;
          background: #ffffff;
          box-sizing: border-box;
          border: 1px solid #999999;
          border-radius: 5px;
          cursor: pointer;
        }
        p:nth-child(2) {
          background: #409eff ;
          border-radius: 5px;
          color: #ffffff;
          border: none;
        }
      }
    }
  }
  // 底图
  .BaseMap {
    width: 100%;
    height: 300px;
    background-image: url("../../assets/imgs/img/beijinglou@2x.png");
    background-size: 100% 100%;
    position: absolute;
    bottom: 0;
  }
}
</style>
